<template>
  <div class="container__div mx-10 my-5">
    <div class="py-3">
      <el-radio-group v-model="route" fill="#0A50E6" text-color="#73c9ff">
        <el-radio-button label="Pedidos">
          <router-link
            :to="{ name: 'DemoOrders' }"
            class="no-underline font-neue uppercase"
          >
            Pedidos
          </router-link>
        </el-radio-button>
        <el-radio-button label="Enviados a Nirex">
          <router-link
            :to="{ name: 'DemoList' }"
            class="no-underline font-neue uppercase"
          >
            Enviados a Nirex
          </router-link>
        </el-radio-button>
      </el-radio-group>
    </div>
    <h2 class="text-2xl mb-4 text-white">Lista de órdenes enviados a Nirex</h2>
    <div class="flex justify-center table__example" style="width: 100%">
      <el-table ref="multipleTable" :data="orders" class="table__style">
        <el-table-column label="Order Id">
          <template slot-scope="scope">
            {{ scope.row.id }}
          </template>
        </el-table-column>
        <el-table-column label="Estado">
          <template slot-scope="scope">
            {{ scope.row.status }}
          </template>
        </el-table-column>
        <el-table-column label="Numero de puntos" width="200">
          <template slot-scope="scope">
            {{ scope.row.points.length }}
          </template>
        </el-table-column>
        <el-table-column label="Precio" width="120">
          <template slot-scope="scope">
            {{ toPEN(scope.row.amount) }}
          </template>
        </el-table-column>
        <el-table-column label="Servicio" width="120">
          <template slot-scope="scope">
            {{ scope.row.service }}
          </template>
        </el-table-column>
        <el-table-column label="Vehiculo" width="120">
          <template slot-scope="scope">
            {{ scope.row.vehicle }}
          </template>
        </el-table-column>
        <el-table-column label="Detalle">
          <template slot-scope="scope">
            <a
              class="text-dark-purple text-xl"
              :href="`/demo/orders/${scope.row.id}`"
            >
              <i class="el-icon-view text-dark-purple text-xl" />
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      orders: [],
      points: [],
      errorMessage: "",
      route: "Enviados a Nirex",
    };
  },
  mounted() {
    this.getOrders();
  },
  methods: {
    async getOrders() {
      try {
        const response = await axios.get(
          "https://api-staging.nirex.pe/api/orders",
          {
            headers: {
              Key: "69a92ae5-a860-411b-8745-6de5016db145",
              "Content-Type": "application/json",
            },
          }
        );
        this.orders = response.data;
      } catch (error) {
        if (error.response.status === 400) {
          this.errorMessage = error.response.data.errors[0].msg;
        }
      }
    },
    toPEN(cents) {
      return "S/." + (cents / 100.0).toFixed(2);
    },
  },
};
</script>
<style lang="scss" scoped>
.el-select {
  margin-top: 20px;
  width: 500px;
  margin-left: 40px;
}

.container__div {
  max-width: 1360px;
  margin: 0 auto;

  @media only screen and (max-width: 1361px) {
    padding: 0 4%;
  }
}

.table__example {
  height: 55vh;
  overflow-y: scroll;
  @media only screen and (min-width: 1500px) {
    height: 65vh;
  }
}
.table__style {
  width: 100%;
  overflow-y: scroll;
}
</style>
